import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import type { MarketplaceBrand, ResolvedPreviewHref } from "./MarketplaceItemPreviewCard.types";
import MarketplaceCopyListingButton from "./MarketplaceCopyListingButton";
import MarketplaceExternalOpenIcon from "./MarketplaceExternalOpenIcon";
interface MarketplaceFullFooterProps {
  readonly href: string;
  readonly resolvedPreviewHref: ResolvedPreviewHref;
  readonly displayTitle: string;
  readonly ctaAriaLabel: string;
  readonly hideActions: boolean;
  readonly hasPrice: boolean;
  readonly priceValueText: string;
  readonly priceCurrencyText?: string | undefined;
  readonly marketplaceBrand: MarketplaceBrand | null;
}
export default function MarketplaceFullFooter(t0) {
  const $ = _c(21);
  const {
    href,
    resolvedPreviewHref,
    displayTitle,
    ctaAriaLabel,
    hideActions,
    hasPrice,
    priceValueText,
    priceCurrencyText,
    marketplaceBrand
  } = t0;
  const {
    href: resolvedHref,
    target,
    rel
  } = resolvedPreviewHref;
  const hasMarketplaceBrand = marketplaceBrand !== null;
  let t1;
  if ($[0] !== displayTitle) {
    t1 = <p className="tw-m-0 tw-min-w-0 tw-flex-1 tw-truncate tw-text-sm tw-font-semibold tw-leading-5 tw-text-white" data-testid="marketplace-item-title">{displayTitle}</p>;
    $[0] = displayTitle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== ctaAriaLabel || $[3] !== hasMarketplaceBrand || $[4] !== hasPrice || $[5] !== marketplaceBrand || $[6] !== priceCurrencyText || $[7] !== priceValueText || $[8] !== rel || $[9] !== resolvedHref || $[10] !== target) {
    t2 = hasPrice || hasMarketplaceBrand ? <Link href={resolvedHref} target={target} rel={rel} prefetch={false} className="tw-inline-flex tw-max-w-[13rem] tw-items-center tw-gap-1.5 tw-rounded-full tw-border tw-border-solid tw-border-white tw-bg-[#E5E5E5] tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-leading-4 tw-text-[#0A0A0A] tw-no-underline tw-transition-colors tw-duration-150 hover:tw-border-[#EFEFEF] hover:tw-bg-[#EFEFEF] hover:tw-text-[#0A0A0A]" data-testid="marketplace-item-cta-link" aria-label={ctaAriaLabel} onClick={_temp} onMouseDown={_temp2} onTouchStart={_temp3}>{hasMarketplaceBrand && <Image src={marketplaceBrand.logoSrc} alt={`${marketplaceBrand.displayName} logo`} width={14} height={14} className="tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-rounded-sm tw-object-cover" />}{hasPrice && <span className="tw-max-w-[8rem] tw-truncate" data-testid="marketplace-item-price">{priceValueText}</span>}{hasPrice && priceCurrencyText && <span className="tw-max-w-[6rem] tw-truncate" data-testid="marketplace-item-price-currency">{priceCurrencyText}</span>}</Link> : <Link href={resolvedHref} target={target} rel={rel} prefetch={false} className="tw-inline-flex tw-size-8 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-white/15 tw-bg-black/50 tw-text-white tw-no-underline tw-transition-colors tw-duration-150" data-testid="marketplace-item-cta-link" aria-label={ctaAriaLabel} onClick={_temp4} onMouseDown={_temp5} onTouchStart={_temp6}><MarketplaceExternalOpenIcon className="tw-size-3.5 tw-flex-shrink-0" /></Link>;
    $[2] = ctaAriaLabel;
    $[3] = hasMarketplaceBrand;
    $[4] = hasPrice;
    $[5] = marketplaceBrand;
    $[6] = priceCurrencyText;
    $[7] = priceValueText;
    $[8] = rel;
    $[9] = resolvedHref;
    $[10] = target;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== hideActions || $[13] !== href) {
    t3 = !hideActions && <MarketplaceCopyListingButton href={href} testId="marketplace-item-copy-button" className="tw-flex tw-size-8 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-white/15 tw-bg-black/50 tw-text-white tw-transition-colors tw-duration-150" />;
    $[12] = hideActions;
    $[13] = href;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== t2 || $[16] !== t3) {
    t4 = <div className="tw-flex tw-flex-shrink-0 tw-items-center tw-gap-2">{t2}{t3}</div>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== t1 || $[19] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-bg-black/60 tw-px-3 tw-py-2.5" data-testid="marketplace-item-footer">{t1}{t4}</div>;
    $[18] = t1;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
}
function _temp6(event_4) {
  return event_4.stopPropagation();
}
function _temp5(event_3) {
  return event_3.stopPropagation();
}
function _temp4(event_2) {
  return event_2.stopPropagation();
}
function _temp3(event_1) {
  return event_1.stopPropagation();
}
function _temp2(event_0) {
  return event_0.stopPropagation();
}
function _temp(event) {
  return event.stopPropagation();
}